import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext.jsx';

/**
 * Wizard Breadcrumbs Component
 * Shows navigation breadcrumbs for the wizard interface
 */
const WizardBreadcrumbs = ({ 
  currentStep = 1, 
  isEditing = false,
  parrotId = null,
  className = '' 
}) => {
  const { theme } = useTheme();

  const breadcrumbItems = [
    {
      label: 'Parrots',
      href: '/parrots',
      isLink: true
    },
    {
      label: isEditing ? 'Edit Parrot' : 'New Parrot',
      href: null,
      isLink: false
    },
    {
      label: `Step ${currentStep}`,
      href: null,
      isLink: false
    }
  ];

  return (
    <nav className={`wizard-breadcrumbs ${className}`} aria-label="Breadcrumb">
      <div className="flex items-center space-x-2 text-sm">
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          
          return (
            <React.Fragment key={index}>
              {item.isLink ? (
                <Link 
                  to={item.href}
                  className="text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={
                  isLast 
                    ? 'text-gray-900 dark:text-white font-medium'
                    : 'text-gray-500 dark:text-gray-400'
                }>
                  {item.label}
                </span>
              )}
              
              {!isLast && (
                <svg 
                  className="w-4 h-4 text-gray-400" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 5l7 7-7 7" 
                  />
                </svg>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};

export default WizardBreadcrumbs;
